import { mergeTranslations } from "ra-core";

import { italianCrmMessages } from "./italianCrmMessages";
import { italianRaMessages } from "./italianRaMessages";
import { italianRaSupabaseMessages } from "./italianRaSupabaseMessages";
import {
  tenaxTasksEnglishMessages,
  tenaxTasksItalianMessages,
} from "./tenaxTasksMessages";
import {
  tenaxPeopleEnglishMessages,
  tenaxPeopleItalianMessages,
} from "./tenaxPeopleMessages";
import {
  tenaxDealsEnglishMessages,
  tenaxDealsItalianMessages,
} from "./tenaxDealsMessages";
import {
  tenaxTimelineEnglishMessages,
  tenaxTimelineItalianMessages,
} from "./tenaxTimelineMessages";
import {
  tenaxAgreementsEnglishMessages,
  tenaxAgreementsItalianMessages,
} from "./tenaxAgreementsMessages";
import {
  tenaxRacketsEnglishMessages,
  tenaxRacketsItalianMessages,
} from "./tenaxRacketsMessages";
import {
  tenaxMobileEnglishMessages,
  tenaxMobileItalianMessages,
} from "./tenaxMobileMessages";

// Keys used by Atomic components but missing from englishCrmMessages.
export const tenaxEnglishExtraMessages = mergeTranslations(
  { resources: { deals: { forcedCaseName: "Deal" } } },
  tenaxTasksEnglishMessages,
  tenaxPeopleEnglishMessages,
  tenaxDealsEnglishMessages,
  tenaxTimelineEnglishMessages,
  tenaxAgreementsEnglishMessages,
  tenaxRacketsEnglishMessages,
  tenaxMobileEnglishMessages,
);

const tenaxItalianExtraMessages = mergeTranslations(
  { resources: { deals: { forcedCaseName: "Trattativa" } } },
  tenaxTasksItalianMessages,
  tenaxPeopleItalianMessages,
  tenaxDealsItalianMessages,
  tenaxTimelineItalianMessages,
  tenaxAgreementsItalianMessages,
  tenaxRacketsItalianMessages,
  tenaxMobileItalianMessages,
);

// Italian messages only: i18nProvider merges them over the English catalog,
// so any key missing here falls back to English.
export const italianMessages = mergeTranslations(
  italianRaMessages,
  italianRaSupabaseMessages,
  italianCrmMessages,
  tenaxItalianExtraMessages,
);
